import Ajv from 'ajv';
import * as ValidationScheme from './scheme.json';

const ajv = new Ajv();
export const ValidationValidator = ajv.compile(ValidationScheme);
